import { UserEarnDetailResponseTenorItem, UserEarnOfferListResponseDataItemTenorItem } from '@utx/utx-client';

export const getEarnTenorTranslationKey = (
  tenor?: Array<UserEarnOfferListResponseDataItemTenorItem> | Array<UserEarnDetailResponseTenorItem> | null
) => {
  if (!tenor) return { key: 'earn-invest::glossary.flexible' };

  if (tenor === null) {
    return {
      key: 'earn-invest::glossary.flexible'
    };
  }

  const plural = Number(tenor[0]) > 1;

  return {
    key: plural ? 'earn-invest::glossary.days' : 'earn-invest::glossary.day',
    options: { day: tenor[0] }
  };
};
